import { render, staticRenderFns } from "./RequestWrapper.vue?vue&type=template&id=1f8e89da"
import script from "./RequestWrapper.vue?vue&type=script&lang=js"
export * from "./RequestWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8e89da')) {
      api.createRecord('1f8e89da', component.options)
    } else {
      api.reload('1f8e89da', component.options)
    }
    module.hot.accept("./RequestWrapper.vue?vue&type=template&id=1f8e89da", function () {
      api.rerender('1f8e89da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/compensatoryService/RequestWrapper.vue"
export default component.exports